import React from "react";
import { Link } from "react-router-dom";
import { useTranslation, LangType } from "./hooks/useTranslation";
import { getStorySlug } from "./methods";
import { Story1 } from "./stories/Story1";
import { Story2 } from "./stories/Story2";
import { Story3 } from "./stories/Story3";
import { Story4 } from "./stories/Story4";
import { Story5 } from "./stories/Story5";
import { Story6 } from "./stories/Story6";

export const allStories = [Story2, Story3, Story4, Story5, Story1, Story6];

interface StoryType {
  EN: { header: string };
  UA: { header: string };
}

interface StoriesProps {
  lang: LangType;
}

export const Stories: React.FC<StoriesProps> = ({ lang }) => {
  const t = useTranslation(lang);
  return (
    <main className="page-container">
      <section className="stories">
        <h3>{t("contentTitle")}</h3>
        {allStories.map((story: StoryType) => (
          <Link key={story[lang].header} to={getStorySlug(story["EN"].header)}>
            {story[lang].header}
          </Link>
        ))}
      </section>
    </main>
  );
};
